export default class RouteDetail {

    constructor(el){
        this.el = el;
        this.dropDownParent = document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div");

        this.printDropdown = document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > h3:nth-child(6)");
        this.printDropdownContent = document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > div:nth-child(7)");

        this.downloadDropdown = document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > h3:nth-child(8)");
        this.downloadDropdownContent = document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > div:nth-child(9)");

        this.dropDownParent.removeChild(this.downloadDropdown);
        this.dropDownParent.removeChild(this.downloadDropdownContent);

        this.dropDownParent.insertBefore(this.downloadDropdown, this.printDropdown);
        this.dropDownParent.insertBefore(this.downloadDropdownContent, this.printDropdown);
        this.init();
    }

    init(){
        this.printDropdown.addEventListener("click", this.handlePrintClick);
        this.downloadDropdown.addEventListener("click", this.handleDownloadClick);
    }

    handlePrintClick(e){
        var downloadDropdown = document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > h3:nth-child(6)")
        if(downloadDropdown.classList.contains("routeYou_downloadSectionActive")){
            downloadDropdown.classList.remove("routeYou_downloadSectionActive");
            document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > div:nth-child(7)").style.height = "0px";
        }
        
    }

    handleDownloadClick(e){
        var printDropdown = document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > h3:nth-child(8)");
        if(printDropdown.classList.contains("routeYou_downloadSectionActive")){
            printDropdown.classList.remove("routeYou_downloadSectionActive");
            document.querySelector("#routeYouRouteViewerTabPane > div:nth-child(2) > div > div:nth-child(9)").style.height = "0px";
        }
    }

    
}